import React from 'react';
import ReactDOM from 'react-dom';
import RootContainer from './components/RootContainer';
import './assets/main.css';

import {Provider} from 'react-redux';
import createStore from './store/Store';
import registerServiceWorker from './registerServiceWorker';

const store = createStore();

ReactDOM.render(
    <Provider store={store}>       
        <RootContainer/>       
    </Provider>,    
    document.getElementById('root')
);


registerServiceWorker();
